import { avatarUrl, usePersonalAppearance } from '../lib/appearance.js';
import { initials } from '../lib/format.js';

type AvatarSize = 24 | 32 | 56 | 96;

const SIZE_CLASSES: Record<AvatarSize, string> = {
  24: 'avatar-size-24',
  32: 'avatar-size-32',
  56: 'avatar-size-56',
  96: 'avatar-size-96',
};

/** Stable string hash: returns a non-negative integer. */
function stringHash(s: string): number {
  let h = 0;
  for (let i = 0; i < s.length; i++) {
    h = (Math.imul(31, h) + s.charCodeAt(i)) | 0;
  }
  return Math.abs(h);
}

export function getAvatarColorIndex(id: string): number {
  return stringHash(id) % 8;
}

export interface AvatarProps {
  name: string;
  id: string;
  size: AvatarSize;
  bot?: boolean;
  /** The assistant artwork to show for the bot; absent shows the viewer's own choice. */
  avatarId?: string;
}

export function Avatar({ name, id, size, bot, avatarId }: AvatarProps) {
  const personal = usePersonalAppearance();
  const colorIdx = getAvatarColorIndex(id);
  const className = bot
    ? `avatar avatar-bot ${SIZE_CLASSES[size]}`
    : `avatar avatar-person avatar-c${colorIdx + 1} ${SIZE_CLASSES[size]}`;

  if (bot) {
    return (
      <img
        src={avatarUrl(avatarId ?? personal)}
        alt=""
        className={className}
        aria-hidden="true"
      />
    );
  }

  return (
    <span className={className} aria-label={`${name}: ${initials(name)}`}>
      {initials(name)}
    </span>
  );
}
